import { useEffect } from 'react'

import { useTailgateGridTestIncidentVideoQuery } from '@/graphql/generated/hooks'

const URL_REFRESH_MARGIN_MS = 60_000

interface UseTailgateGridTestIncidentVideoIProps {
  incidentId?: string
  isEnabled: boolean
}

export const useTailgateGridTestIncidentVideo = ({
  incidentId,
  isEnabled,
}: UseTailgateGridTestIncidentVideoIProps) => {
  const {
    data,
    error,
    loading: isLoading,
    refetch,
  } = useTailgateGridTestIncidentVideoQuery({
    variables: { id: incidentId ?? '' },
    skip: !isEnabled || !incidentId,
    fetchPolicy: 'no-cache',
  })

  const expiryTime = data?.incident?.video?.expiryTime

  useEffect(() => {
    if (!isEnabled || !incidentId || !expiryTime) return

    const expiresAt = Date.parse(expiryTime)
    if (Number.isNaN(expiresAt)) return

    const refreshTimer = setTimeout(() => {
      void refetch().catch(() => undefined)
    }, Math.max(0, expiresAt - Date.now() - URL_REFRESH_MARGIN_MS))

    return () => clearTimeout(refreshTimer)
  }, [expiryTime, incidentId, isEnabled, refetch])

  return {
    isError:
      isEnabled &&
      Boolean(incidentId) &&
      (Boolean(error) || (!isLoading && !data?.incident?.video?.url)),
    isLoading,
    videoUrl: data?.incident?.video?.url ?? null,
  }
}
